module.exports = __webpack_public_path__ + "static/media/herobg.cec6ca2d.svg";